// @vendors
const Immutable = require('immutable');

// @ constants
const actionTypes = require('constants/actionTypes');

// @ helpers
const { parseContracts } = require('./brokerCustomWalletParseHelper');

const REPEATED_NAME_MESSAGE = 'There is already a user portfolio with description';

const initialState = () => {
    return Immutable.fromJS({
        viewName: '',
        contracts: [],
        contractsJoined: '',
        idPortfolioAccount: '',
        validation: {
            nameIsValid: true,
            atLeastOneContract: true,
            showAtLeastOneContractError: false,
            repeatedName: false,
            isValid: false,
            showViewNameErrors: false,
            onlyUnconsolidatedContracts: false
        },
        contractRequest: {
            isFetching: false,
            success: false,
            errorMsg: '',
            failure: false
        },
        saveRequest: {
            isFetching: false,
            success: false,
            error: {},
            errorMsg: ''
        },
        setDefaultOnCreate: false
    });
};

const loadPortfolioBuffer = (immWallet,state) => {
    return initialState().merge(Immutable.fromJS({
        viewName: state.get('viewName'),
        contracts: immWallet.get('contracts'),
        idPortfolioAccount: immWallet.get('idPortfolioAccount')
    }));
}

const joinContracts = contracts => {
    const contractsEnable = contracts.filter(contract => {
        if(contract.get('personalizable')) {
            return contract.get('enabled');
        }
    });

    return contractsEnable.reduce((contractsJoined, contract) => {
        if (contractsJoined === '') {
            contractsJoined = '' + contract.get('idCartera');
        } else {
            contractsJoined += '|' + contract.get('idCartera');
        }

        return contractsJoined;
    },'');
}

const findRepeatedName = (viewName, viewId, currentWallets) => {
    let repeated = false;

    if (viewId !== "") { //vista en modo edición
        repeated = !!currentWallets
            .filter(w => w.idPortfolioAccount !== viewId)
            .find(w => w.descriptionPortfolioAccount === viewName.toLowerCase());
    } else {
        repeated = !!currentWallets.find(w => w.descriptionPortfolioAccount === viewName.toLowerCase());
    }

    return repeated;
}

const validate = (state, currentWallets) => {
    const viewName = state.get('viewName');
    const viewId = state.get('idPortfolioAccount');
    const contractsJoined = joinContracts(state.get('contracts'));
    const nameIsValid = viewName.trim().length !== 0;
    const atLeastOneContract = contractsJoined !== '';
    const repeatedName = findRepeatedName(viewName, viewId, currentWallets);
    const isValid = nameIsValid && atLeastOneContract && !repeatedName;

    return state.mergeDeep(Immutable.fromJS({
        validation: {
            isValid: isValid,
            nameIsValid: nameIsValid,
            atLeastOneContract: atLeastOneContract,
            repeatedName
        },
        contractsJoined: contractsJoined
    }));
};

const atLeastOneContractEnable = (contracts) => {
    let atLeastOneContractEnable = false;
    contracts.map(contract => {
        if (contract.get('enabled')) {
            atLeastOneContractEnable = true;
        }
    });
    return atLeastOneContractEnable;
}

const changeContractEnabled = (immState, contractNumber) => {
    const newList = immState.get('contracts').map(contract => {
        if (contract.get('portfolioId') === contractNumber) {
            const enabled = !contract.get('enabled');

            return contract.set('enabled',enabled);
        }
        return contract;
    });

    return immState.mergeDeep(Immutable.fromJS({
        contracts: newList,
        validation: {
            atLeastOneContract: atLeastOneContractEnable(newList),
            showAtLeastOneContractError: false
        },
    }));
}

const saveRequestError = (immState, error) => {
    const message = error && error.description && error.description.message;

    if (message.indexOf(REPEATED_NAME_MESSAGE) > -1) {
        return immState.mergeDeep(Immutable.fromJS({
            validation: {
                repeatedName: true
            },
            saveRequest: {
                success: false,
                isFetching: false
            }
        }));
    } else {
        return immState.mergeDeep(Immutable.fromJS({
            saveRequest: {
                success: false,
                isFetching: false
            }
        }));
    }
}

const hasOnlyUnconsolidatedContracts = (contracts) => {
    const customContract = contracts.find(contract => contract.personalizable === true) 
    return  customContract ? false : true;
}

const brokerCustomWalletEditablePortfolio = (state = initialState(), action) => {
    switch (action.type) {
        case actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_INIT:
            return initialState();
        case actionTypes.BROKER_CUSTOM_WALLET_LOAD_PORTFOLIO_BUFFER:
            return loadPortfolioBuffer(action.payload, state);
        case actionTypes.BROKER_CUSTOM_WALLET_VALIDATE:
            return validate(state, action.payload.currentWallets);
        case actionTypes.BROKER_CUSTOM_WALLET_SHOW_VALIDATION_ERRORS:
            return state.mergeDeep(Immutable.fromJS({
                validation: {
                    showAtLeastOneContractError: !state.getIn(['validation', 'atLeastOneContract']),
                    showViewNameErrors: !state.getIn(['validation', 'nameIsValid']) || state.getIn(['validation', 'repeatedName']),
                }
            }));
        case actionTypes.BROKER_CUSTOM_WALLET_NAME_CHANGE:
            return state.mergeDeep(Immutable.fromJS({
                viewName: action.payload,
                validation: {
                    showViewNameErrors: false
                },
                contractsJoined: joinContracts(state.get('contracts'))
            }));
        case actionTypes.BROKER_CUSTOM_WALLET_CONTRACT_ITEM_CHANGE_ENABLED:
            return changeContractEnabled(state, action.payload.contractNumber);
        case actionTypes.BROKER_CUSTOM_WALLET_SAVE_SUCCESS:
            return state.mergeDeep(Immutable.fromJS({
                saveRequest: {
                    success: true,
                    isFetching: false
                }
            }));
        case actionTypes.BROKER_CUSTOM_WALLET_SAVE_ERROR:
            return saveRequestError(state, action.payload.error);
        case actionTypes.BROKER_CUSTOM_WALLET_SAVE_REQUEST:
            return state.mergeDeep(Immutable.fromJS({
                saveRequest: {
                    success: false,
                    isFetching: true
                }
            }));
        case actionTypes.BROKER_CUSTOM_WALLET_CONTRACT_LIST_SUCCESS:
            const enableAllContracts = true;
            const parsedContracts = parseContracts(action.payload, enableAllContracts, action.enabledProducts);
            const onlyUnconsolidatedContracts = hasOnlyUnconsolidatedContracts(parsedContracts);
            return state.mergeDeep(Immutable.fromJS({
                contracts: parsedContracts,
                contractRequest: {
                    success: true,
                    isFetching: false,
                    failure: false
                },
                validation: {
                    onlyUnconsolidatedContracts: onlyUnconsolidatedContracts
                }
            }));
        case actionTypes.BROKER_CUSTOM_WALLET_CONTRACT_LIST_BY_PORTFOLIO_REQUEST:
            return state.mergeDeep(Immutable.fromJS({
                contractRequest: {
                    success: false,
                    isFetching: true,
                    failure: false
                }
            }));
        case actionTypes.BROKER_CUSTOM_WALLET_CONTRACT_LIST_BY_PORTFOLIO_SUCCESS:
            return state.mergeDeep(Immutable.fromJS({
                contractRequest: {
                    success: true,
                    isFetching: false,
                    failure: false
                }
            }));
        case actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_SET_ON_EDIT_MODE_ACCEPT:
            return state.merge({
                viewName: action.payload.name
            });
        case actionTypes.BROKER_CUSTOM_WALLET_CONTRACT_LIST_ERROR:
            return state.mergeDeep(Immutable.fromJS({
                contractRequest: {
                    success: false,
                    isFetching: false,
                    failure: true
                }
            }));
        case actionTypes.BROKER_CUSTOM_WALLET_CONTRACT_LIST_REQUEST:
            return state.mergeDeep(Immutable.fromJS({
                contractRequest: {
                    success: false,
                    isFetching: true,
                    failure: false
                }
            }));
        case actionTypes.BROKER_CUSTOM_WALLET_PORFOLIO_ENABLE_ALL_CONTRACTS_BY_TYPE:
            const newState = state.update('contracts', contracts => contracts.map(contract => {
                if (contract.get('portfolioType') === action.payload) {
                    return contract.set('enabled', true)
                }

                return contract;
            }))

            const atLeastOneContract = atLeastOneContractEnable(newState.get('contracts'));
            return newState.mergeDeep(Immutable.fromJS({
                validation: {
                    atLeastOneContract,
                    showAtLeastOneContractError: !atLeastOneContract,
                },
            }));
        case actionTypes.BROKER_CUSTOM_WALLET_PORFOLIO_DISABLE_ALL_CONTRACTS_BY_TYPE:
            return state.update('contracts', contracts => contracts.map(c => {
                if (c.get('portfolioType') === action.payload) {
                    return c.set('enabled', false)
                }

                return c;
            }));
        case actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_SET_DEFAULT_ON_CREATE:
            return state.merge({
                setDefaultOnCreate: action.payload.setPortfolioDefaulChecked
            })
        case actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_CANCEL_EDITION:
            return initialState();
        default:
            return state;
    }
};

module.exports.brokerCustomWalletEditablePortfolio = brokerCustomWalletEditablePortfolio;
